// Read-only fixed-price opt-in stamps + the ops-side Clear action. The
// opt-in itself is a crew's own commitment made from the crew app (see
// apps/api/src/modules/vendor/fixed-price.ts) — ops cannot set it from here,
// only revoke it, which is why this renders stamps + a single button rather
// than a form field like VendorAutoAssignField.
import { RowAction } from '@/components/RowAction';
import type { AdminVendorDetail } from '@/lib/admin-api';

export function VendorFixedPriceField({
  vendor,
  onClear,
  busy,
}: {
  vendor: AdminVendorDetail;
  onClear: () => void;
  busy?: boolean;
}) {
  if (!vendor.fixedPriceOptin) {
    return <span className="text-[12.5px] text-[color:var(--bo-mute)]">Not opted in</span>;
  }

  const optinDate = vendor.fixedPriceOptinAt
    ? new Date(vendor.fixedPriceOptinAt).toLocaleDateString()
    : '—';
  const confirmedDate = vendor.pricesConfirmedAt
    ? new Date(vendor.pricesConfirmedAt).toLocaleDateString()
    : '—';

  return (
    <div className="flex items-center gap-2">
      <span className="text-[12.5px]">
        Opted in on {optinDate} · prices confirmed {confirmedDate}
      </span>
      <RowAction kind="danger" busy={busy} onClick={onClear}>
        Clear opt-in
      </RowAction>
    </div>
  );
}
